import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postSearchLTPlannerMaterial = createApi(`SearchLTPlannerMaterialSlice`,"POST");

const SearchLTPlannerMaterialSlice = createSlice({
  name: 'SearchLTPlannerMaterialSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postSearchLTPlannerMaterial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postSearchLTPlannerMaterial.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postSearchLTPlannerMaterial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SearchLTPlannerMaterialSlice.reducer;